module.exports = __webpack_public_path__ + "img/youngtoy.d7b30a9f.svg";